import React, { Component, useState, useRef, useEffect } from 'react';
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import { useHistory } from 'react-router-dom';
import { ApiService } from '../../containers/Services/apiservice';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { Helmet } from 'react-helmet';
import { Watch } from "react-loader-spinner";
let apiServices = new ApiService();
let counter = 0;
const RiskAssestment = () => {
    let history = useHistory();
    const [questionsData, setQuestionsData] = React.useState([]);
    const [selectedOptionsList, setselectedOptionList] = useState();
    const [spinnerLoading, setSpinnerLoading] = useState(false);
    const [selectedOptionsData, setselectedOptionData] = useState(0);
    const [totalScoreData, setTotalScoreData] = useState(0);
    const [showScoreData, setShowScoreData] = useState(false);
    const [hideprev, sethidePrevData] = useState(true);
    const [riskprofile, setRiskProfile] = useState('');
    const [prevdata, setPrevData] = useState();
    const [prevsel, setPrevSel] = useState();
    const didMountRef = useRef(true);
    useEffect(() => {
        if (didMountRef.current) {
            setSpinnerLoading(true);
            apiServices.questionGetRequest().then(result => {
                if (result.data.status == 'success') {
                    setQuestionsData(result.data.data)
                    setSpinnerLoading(false);
                }
            })
        }
        didMountRef.current = false;
    }, []);
    const skipriskassetment = (e) => {
        history.push("/goalsettings");
    };
    // console.log("dataa",questionsData);
    const nextStep = (question) => {
        if (selectedOptionsData === 0) {
            alert('Please select option');
            return false;
        }
        counter++;
        const dataString = {
            "question_id": question.rpq_id,
            "option_id": selectedOptionsData,
            "count": counter,
            "totalscore": totalScoreData
        }
        apiServices.saveQuestionData(dataString).then(result => {
            if (result.data.status == 'success') {
                setTotalScoreData(Number(Number(totalScoreData) + Number(result.data.saveans.rpqa_score)).toFixed(1))
                if (result.data.data == 0) {
                    const dataStringnew = {
                        "totalscore": Number(Number(totalScoreData) + Number(result.data.saveans.rpqa_score)).toFixed(1)
                    }
                    apiServices.saveriskscore(dataStringnew).then(res => {
                        if (res.data.status == 'success') {
                            if (res.data.riskprofile) {
                                setRiskProfile(res.data.riskprofile)
                            }
                            setShowScoreData(true)
                        }
                        else if (result.data.status == "error" && result.data.message == "Session expired") {
                            localStorage.removeItem('AUTH_TOKEN');
                            // alert(result.data.message)
                            setSpinnerLoading(false)
                            history.push("/login")
                        }
                        else {
                            alert(result.data.message)
                            setSpinnerLoading(false)
                            return false
                        }
                    })
                } else {
                    sethidePrevData(false)
                    setQuestionsData(result.data.data)
                    if (result.data.optionsel) {
                        setPrevData(result.data.data)
                        setPrevSel(result.data.optionsel)
                        setselectedOptionList(result.data.optionsel)
                        setselectedOptionData(result.data.optiondata)
                    } else {
                        setselectedOptionList()
                        // setselectedOptionData(0)
                    }
                }
            }
            else if (result.data.status == "error" && result.data.message == "Session expired") {
                localStorage.removeItem('AUTH_TOKEN');
                // alert(result.data.message)
                setSpinnerLoading(false)
                history.push("/login")
            }
            else {
                alert(result.data.message)
                setSpinnerLoading(false)
                return false
            }
        })
    }
    const previousStep = (question) => {
        // if(selectedOptionsData===0){
        //     alert('Please select option');
        //     return false;
        // }
        const dataString = {
            "question_id": question.rpq_id,
        }
        apiServices.getprevquesdata(dataString).then(result => {
            if (result.data.status == 'success') {
                if (result.data.data == 0) {
                    setShowScoreData(true)
                } else {
                    if (result.data.ques == 1) {
                        sethidePrevData(true)
                    }
                    setTotalScoreData(Number(Number(totalScoreData) - Number(result.data.saveans.rpqa_score)).toFixed(1))
                    setQuestionsData(result.data.data)
                    setselectedOptionList(result.data.optionsel)

                    // setselectedOptionData(0)
                }
            }
            else if (result.data.status == "error" && result.data.message == "Session expired") {
                localStorage.removeItem('AUTH_TOKEN');
                // alert(result.data.message)
                setSpinnerLoading(false)
                history.push("/login")
            }
            else {
                alert(result.data.message)
                setSpinnerLoading(false)
                return false
            }
        })
    }
    const gotoriskprofile = () => {
        history.push("/risk-assestment");
    }
    const answer = (option, index) => {
        // if(prevsel != null )
        // {
        //     setselectedOptionList(prevsel);
        // }
        // else{       
        setselectedOptionList(index);
        // }
        // if(prevdata != null)
        // {
        // setselectedOptionData(prevdata)
        // }
        // else{
        setselectedOptionData(option.rpqo_id)
        // }
        // setTotalScoreData(Number(totalScoreData)+Number(option.rpqo_option_weightage_score))
    }
    return (
        <div>
            <Header />
            <Helmet>
                <title>RiskAssestment - Goalstox</title>
                {/* <meta name="keywords" content={pageKeywords}/>  */}
                {/* <meta name="description" content={pageDescription} /> */}
            </Helmet>
            <div className='subheader-second'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className='subheader-second-flex'>
                                <h1>Behavioural Risk Profile Survey</h1>
                                {showScoreData == false ?
                                    <button className='ml-auto buttonab-line-2' onClick={skipriskassetment} >Skip Risk Assestment <i class="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></button>
                                    : ""}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className='bg-gray-light section-small'>
                <div className={spinnerLoading == true ? 'parentDisable' : ''} width="100%">
                    <div className='overlay-box'>
                        <Watch
                            color="#ffffff"
                            visible={spinnerLoading}
                        />
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className='row  '>
                        <div className='col-lg-12'>
                            <div className='panel risk-profile-details'>
                                <div className='row justify-content-md-center'>
                                    {
                                        showScoreData == false ?
                                            <div className='col-lg-12'>
                                                <h4 className='tx-theme tx-center mg-t-20'>How much risk can you take?</h4>
                                                <p className='tx-center'>Some questions that can help you know your risk appetite and demographic score</p>
                                                <div className='riskbox'>
                                                    <div className='riskbox-header tx-theme'>Q{questionsData.rpq_question}</div>
                                                    <div className='riskbox-body'>
                                                        {
                                                            questionsData.rpq_question_image != null ? <img className='questionimg' src={questionsData.rpq_question_image} /> : ''
                                                        }
                                                        {
                                                            questionsData.options ? questionsData.options.map((option, index) => <div className={selectedOptionsList === index ? "riskbox-question active" : "riskbox-question"} key={index} onClick={() => { answer(option, index); }}><span className='circle'></span><span className='qname'>{option.rpqo_option}</span></div>) : null
                                                        }
                                                    </div>
                                                    <div className='riskbox-footer'>
                                                        {hideprev == false ?
                                                            <button className='mg-r-15 btn' onClick={() => { previousStep(questionsData); }}>Previous</button> : ''
                                                        }
                                                        <button className='btn' onClick={() => { nextStep(questionsData); }}>Next</button>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div className="col-lg-4">
                                                <div className='tx-center'>
                                                    <h5 className='mg-b-10'>Your Risk Profile</h5>
                                                    <span> {riskprofile}({totalScoreData}) </span>
                                                    {/* <span> {riskprofile}({totalScoreData.toFixed(2)}) </span>    */}
                                                    <div className="tx-center" style={{ width: 150, height: 150, margin: "20px auto" }}>
                                                        <CircularProgressbar value={totalScoreData} text={`${totalScoreData}`} />
                                                    </div>
                                                    <button onClick={skipriskassetment} className="buttonab-line mg-t-20">Set Your Goal<i class="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></button>
                                                </div>
                                            </div>
                                    }
                                    {/* {
                         showScoreData==true?
                         <div className='row justify-content-md-center'>
                            <div className="col-lg-4 tx-center"><button className='btn mg-t-20' onClick={skipriskassetment} >Set Your Goals</button>
                            </div>
                            </div>:''
                        } */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="login-media align-items-stretch justify-content-center ht-00p">

                                <div className="wd-100p">
                                    <h4>Behavioural Risk Profile Survey</h4>
                                        <div className="form-group">
                                            <label>Name</label>
                                            <input type="name" name="user_name"   className="form-control" placeholder="Enter Name" />
                                        </div>
                                        <div className="form-group">
                                            <label>1. What is your current age ?</label>
                                            <input type="radio" value ="1" onChange={handleInput} name="q1" required /> &gt; 55<br />
                                            <input type="radio" value ="2" onChange={handleInput} name="q1"/> 45 to 54<br />
                                            <input type="radio" value ="3" onChange={handleInput} name="q1"/> 35 to 44<br />
                                            <input type="radio" value ="4" onChange={handleInput} name="q1"/> &lt; 35
                                        </div>
                                        <div className="form-group">
                                            <label>2. How comfortable are you with financial markets (like stock markets or equity mutual funds) ?</label>
                                            <input type="radio"  value ="1" onChange={handleInput} name="q2"/> I have not invested in stocks or equity mutual funds ever.<br />
                                            <input type="radio"  value ="2" onChange={handleInput} name="q2"/> I invest in stocks OR equity mutual funds based on other's advise, and I do not understand it much<br />
                                            <input type="radio"  value ="3" onChange={handleInput} name="q2"/> I have comfortable experience with stock markets and I invest sometimes in it<br />
                                            <input type="radio"  value ="4" onChange={handleInput} name="q2"/> I am experienced investor, and I understand the markets deeply.
                                        </div>
                                        <div className="form-group">
                                            <label>3. How easily do you adapt when things go wrong financially?</label>
                                            <input type="radio" value ="1" onChange={handleInput} name="q3"/> I panic<br />
                                            <input type="radio" value ="2" onChange={handleInput} name="q3"/> I get disturbed and uneasy<br />
                                            <input type="radio" value ="3" onChange={handleInput} name="q3"/> I am somewhat calm as I know volatility is part of investing<br />
                                            <input type="radio" value ="4" onChange={handleInput} name="q3"/> As far as things are within my calculated limits, I don't take much action and just wait for things to become normal
                                        </div>
                                        <div className="form-group">
                                            <label>4. When you think of the word "risk" in a financial context, which of the following words comes to mind first?</label>
                                            <input type="radio" value ="1" onChange={handleInput} name="q4"/> Danger<br />
                                            <input type="radio" value ="2" onChange={handleInput} name="q4"/> Uncertainty<br />
                                            <input type="radio" value ="3" onChange={handleInput} name="q4"/> Opportunity<br />
                                            <input type="radio" value ="4" onChange={handleInput} name="q4"/> High Returns<br />
                                            <input type="radio" value ="5" onChange={handleInput} name="q4"/> Thrill
                                        </div>
                                        <div className="form-group">
                                            <label>5. What products have you invested in so far</label>
                                            <input type="radio" value ="1" onChange={handleInput} name="q5"/> Bank deposits or government bonds/ government deposits<br />
                                            <input type="radio" value ="2" onChange={handleInput} name="q5"/> Apart from above, also in debt or balanced mutual funds<br />
                                            <input type="radio" value ="3" onChange={handleInput} name="q5"/> Apart from above, also in all types of mutual funds - equity, debt , balanced etc.<br />
                                            <input type="radio" value ="4" onChange={handleInput} name="q5"/> Apart from above, also in Alternate investments such as portfolio management services<br />
                                            <input type="radio" value ="5" onChange={handleInput} name="q5"/> I have also invested in cryptocurrencies as I understand the markets and its associated volatility.
                                        </div>
                                        <div className="form-group">
                                            <label>6. How would you rate your income levels currently ?</label>
                                            <input type="radio" value ="1" onChange={handleInput} name="q6"/> Most of my income goes in meeting my monthly expenses<br />
                                            <input type="radio" value ="2" onChange={handleInput} name="q6"/> I am able to save some amount after meeting my expenses<br />
                                            <input type="radio" value ="3" onChange={handleInput} name="q6"/> I have comfortable income, and can also afford few luxuries of life sometimes<br />
                                            <input type="radio" value ="4" onChange={handleInput} name="q6"/> I have large and stable income.
                                        </div>
                                        <div className="form-group">
                                            <label>7. When faced with a major financial decision, are you more concerned about the possible losses or the possible gains?</label>
                                            <input type="radio" value ="1" onChange={handleInput} name="q7"/> Always the possible losses.<br />
                                            <input type="radio" value ="2" onChange={handleInput} name="q7"/> Usually the possible losses.<br />
                                            <input type="radio" value ="3" onChange={handleInput} name="q7"/> Usually the possible gains.<br />
                                            <input type="radio" value ="4" onChange={handleInput} name="q7"/> Always the possible gains.
                                        </div>
                                        <div className="form-group">
                                            <label>8. How much confidence do you have in your ability to make good financial decisions?</label>
                                            <input type="radio" value ="1" onChange={handleInput} name="q8"/> None<br />
                                            <input type="radio" value ="2" onChange={handleInput} name="q8"/> A little<br />
                                            <input type="radio" value ="3" onChange={handleInput} name="q8"/> A reasonable amount<br />
                                            <input type="radio" value ="4" onChange={handleInput} name="q8"/> Great Deal
                                        </div>
                                        <div className="form-group">
                                            <label>9. Investments can go up or down in value and experts often say you should be prepared to weather a downturn. By how much could the total value of all your investments go down before you would begin to feel uncomfortable?</label>
                                            <input type="radio" value ="1" onChange={handleInput} name="q9"/> Any fall in value would make me feel uncomfortable.<br />
                                            <input type="radio" value ="2" onChange={handleInput} name="q9"/> 10%<br />
                                            <input type="radio" value ="3" onChange={handleInput} name="q9"/> 20%<br />
                                            <input type="radio" value ="4" onChange={handleInput} name="q9"/> 33%<br />
                                            <input type="radio" value ="5" onChange={handleInput} name="q9"/> 50%
                                        </div>
                                        <div className="form-group">
                                            <label>10. If you have to choose only one of these 5 hypothetical portfolios, which one will you select ?</label>
                                            <input type="radio" value ="1" onChange={handleInput} name="q10"/> Portfolio A<br />
                                            <input type="radio" value ="2" onChange={handleInput} name="q10"/> Portfolio B<br />
                                            <input type="radio" value ="3" onChange={handleInput} name="q10"/> Portfolio C<br />
                                            <input type="radio" value ="4" onChange={handleInput} name="q10"/> Portfolio D<br />
                                            <input type="radio" value ="5" onChange={handleInput} name="q10"/> Portfolio E
                                        </div>
                                        <div className="form-group">
                                            <label>11. If a few months after investing, the value of your investments declines by 20%, what would you do? </label>
                                            <input type="radio" value ="1" onChange={handleInput} name="q11"/> Any fall in value would make me feel uncomfortable.<br />
                                            <input type="radio" value ="2" onChange={handleInput} name="q11"/> I would cut the losses and sell all investment immediately<br />
                                            <input type="radio" value ="3" onChange={handleInput} name="q11"/> I would be worried, but I will give my investment some more time to recover<br />
                                            <input type="radio" value ="4" onChange={handleInput} name="q11"/> I would be ok with volatility and accept decline in portfolio value as a part of investing.<br />
                                            <input type="radio" value ="5" onChange={handleInput} name="q11"/> I would buy more at these lower prices. I am confident of my investment and notional losses don't disturb me.
                                        </div>
                                        <div className="form-group">
                                            <label>12. You have Rs 10 Lakhs of your hard earned money. You want to invest it for 10 years, which portfolio below would you most likely invest in ?</label>
                                            <input type="radio" value ="1" onChange={handleInput} name="q12"/> 100 % in Bank fixed deposit<br />
                                            <input type="radio" value ="2" onChange={handleInput} name="q12"/> 80% in bank deposits and 20 % in mutual funds<br />
                                            <input type="radio" value ="3" onChange={handleInput} name="q12"/> 50% in bank deposits and 50% in equity mutual funds<br />
                                            <input type="radio" value ="4" onChange={handleInput} name="q12"/> 20% in bank deposits and 80% in equity funds<br />
                                            <input type="radio" value ="5" onChange={handleInput} name="q12"/> 100% in equity funds as my time horizon for this investment is fairly long
                                        </div>
                                        <button className="btn btn-success button01 mg-b-10" >Submit</button>

                                  </div>

                                  </div> */}
            </section>
            <Footer />
        </div>
    );
}
export default RiskAssestment;